<template>
  <div
    v-if="data.length > 0"
    class="c-table"
  >
    <edit-table
      :option="tableOption"
      :loading="loading"
      :data="data"
    >
      <!-- <template
        slot="menu"
        scope="{row}"
      >
        <feather-icon
          v-if="option.detail"
          icon="SearchIcon"
          class="text-primary cursor-pointer mr-1"
          size="20"
          @click="handleDetail(row)"
        />
        <feather-icon
          v-if="option.assessment"
          icon="FileTextIcon"
          class="text-primary cursor-pointer mr-1"
          size="20"
          @click="handleAssessment(row)"
        />
      </template> -->
    </edit-table>

    <!-- <b-modal
      v-model="detailShow"
      body-class="process-modal"
      size="xl"
      centered
      title="View"
      hide-footer
    >
      <staff-view
        :id="currentData.id"
        :disabled="true"
      />
    </b-modal>

    <b-modal
      v-model="assessmentShow"
      body-class="process-modal"
      size="xl"
      centered
      title="View"
      hide-footer
    >
      <assessment-view
        :staff-id="currentData.id"
        :positivehow="false"
      />
    </b-modal> -->
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue';
import { staff } from '@/api/staff/index';
import WORKER from '@/api/worker/index'

export default {
  components: {
    EditTable,
    // StaffView: () => import('@/views/staff/components/formEdit.vue'),
    // AssessmentView: () => import('@/views/staff/positiveRecord/components/view.vue'),
  },
  props: {
    ids: {
      type: Array,
      default: () => ([]),
    },
    option: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: [],
      loading: false,
      detailShow: false,
      assessmentShow: false,
      currentData: {},
    };
  },
  computed: {
    tableOption() {
      const menuShow = this.option.detail || this.option.assessment
      const option = {
        refresh: false,
        header: false,
        // menu: menuShow || false,
        menu: false,
        editBtn: false,
        delBtn: false,
        disabled: true,
        columns: [
          { label: this.i18n('label.employmentCode'), field: 'employmentCode' },
          { label: this.i18n('label.name'), field: 'name' },
          { label: this.i18n('label.birthday'), field: 'birthday' },
          { label: this.i18n('label.finNo'), field: 'finNo' },
          { label: this.i18n('label.mobile'), field: 'mobile' },
        ],
      };
      return option;
    },
  },
  watch: {
    ids: {
      handler(e, o = []) {
        if (e.join() !== o.join()) {
          if (e.length > 0) {
            this.onload(e.join())
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    onload(ids) {
      if (!ids) { return }
      this.loading = true
      WORKER.getAllEasyList(1, -1, { ids }).then(res => {
        const temp = res.data.data.records
        this.data = temp
        this.loading = false
      })
    },
    // handleDetail(e) {
    //   this.currentData = e.item
    //   this.detailShow = true
    //   console.log(e, 'handleDetail');
    // },
    // handleAssessment(e) {
    //   this.currentData = e.item
    //   this.assessmentShow = true
    //   console.log(e, 'handleAssessment');
    // },
  },
};
</script>

<style lang='scss'>
.c-table {
  .edit-table {
    table {
      td,
      th {
        line-height: 18px;
      }
      .width-200 {
        width: 200px;
      }
    }
  }
}
</style>
